import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

import "./style.css";
import { toggleConfirmReplaceModal } from "../../../redux/slices/sidebarSliders";
import { updateUserActivity } from "../../../redux/slices/userActivity";

export default function ConfirmReplace() {
  const dispatch = useDispatch();
  const { master } = useSelector((state) => state.sidebarSliders.confirmReplaceModal);
  const { selectedUserActivity } = useSelector((state) => state.userActivity);
  const { active: confirmReplaceModalActive } = useSelector((state) => state.sidebarSliders.confirmReplaceModal);

  const handleClose = () => {
    dispatch(toggleConfirmReplaceModal(false));
  };

  const handleReplace = () => {
    dispatch(updateUserActivity({ activity: master, selectedActivityIdx: selectedUserActivity }));
    handleClose();
  };

  return (
    <AnimatePresence>
      {confirmReplaceModalActive && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4, type: "tween", ease: "anticipate" }}
          className="modal_container confirm_replace_modal "
          onClick={handleClose}
        >
          <motion.div
            initial={{ scale: 0.7 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.7 }}
            transition={{ duration: 0.4, type: "tween", ease: "anticipate" }}
            className="modal_basic"
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <div className="modal_header">Changes on current slide will be lost.</div>
              <div className="modal_text">New layout will replace the layout on the selected slide only.</div>
              <div className="action-buttons">
                <button className="btn btn-primary cancel-btn" onClick={handleClose}>
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleReplace}>
                  Replace Layout
                </button>
              </div>
            </div>
            <div className="close-icon icon-button" onClick={handleClose}>
              <img src="/assets/icons/close.svg" alt="" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
